// extracted by mini-css-extract-plugin
module.exports = {"CellGrid":"CellGrid_CellGrid__8cfMJ","isSolved":"CellGrid_isSolved__vCLhI","row":"CellGrid_row__2jJyw","unsolved":"CellGrid_unsolved__1Puss"};